import { isProStudioViewer } from '../utils';
import { useProStudioCtxSelector } from '../xstate/app.xstate';

export const useProStudioViewerRole = () => {
  const { userProjects, projectId } = useProStudioCtxSelector((ctx) => ({
    userProjects: ctx.userProjects,
    projectId: ctx.project?.id,
  }));

  // While userProjects are still loading (undefined), default to restricted mode
  // to prevent edit controls from briefly flashing before data arrives
  if (userProjects === undefined) return true;

  const role = userProjects.find((p) => p.id === projectId)?.role;

  return isProStudioViewer(role ? [role] : []);
};
